<template>
  <structure>
    <div v-if="this.loggedIn" class="mt-2">
      <b-row>
        <b-col>
          <p class="font-weight-bold">Logged in as</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col v-if="this.$store.getters.user">
          <p>{{ this.$store.getters.user.name }}</p>
          <p>{{ this.$store.getters.user.email }}</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <a href="#" @click="logout()">Log out</a>
        </b-col>
      </b-row>
    </div>
    <div v-else class="mt-2">
      <sign-in></sign-in>
    </div>
    <b-row class="mb-1 mt-2 justify-content-center">
      <b-col>
        <small
          class="version"
          @click="incrementDevModeCounter()"
        >v{{ version }} Copyright © 2018-2021 Clockk.com Inc.</small>
      </b-col>
    </b-row>
  </structure>
</template>

<script>
import Structure from "./Structure";
import SignIn from "../tools/SignIn";
import { version } from "../../package.json";

export default {
  name: "Account",
  components: {
    Structure,
    SignIn
  },
  data() {
    return {
      version: version,
      devModeCounter: 0
    };
  },
  extends: Structure,
  mounted() {},
  methods: {
    logout() {
      this.loggedIn = false;
      this.$store.commit("logout");
      if (this.$store.getters.running) this.$store.commit("toggleRunning");
      this.$forceUpdate();
    },
    incrementDevModeCounter() {
      this.devModeCounter++;
      if (this.devModeCounter >= 10) {
        this.$store.commit("toggleDevMode");
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
a {
  text-decoration: none;
  color: red;
}
.version {
  position: fixed;
  font-size: x-small;
}
</style>
